import React from 'react'
import { useTranslation } from 'react-i18next'
import { Gem } from 'lucide-react'

const DoubleWinnerSummary = ({ bets = [], winColor, winSector }) => {
  const { t } = useTranslation()

  const winners = (Array.isArray(bets) ? bets : []).filter((bet) => Boolean(bet.win))
  if (winners.length === 0) {
    return null
  }

  const winColorLabel = winColor === 'red'
    ? t('double.colors.red', 'Красный')
    : winColor === 'black'
      ? t('double.colors.black', 'Чёрный')
      : t('double.colors.green', 'Зелёный')

  return (
    <div className="rounded-2xl border border-emerald-300/30 bg-emerald-500/10 p-4 lg:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h3 className="text-white font-semibold">{t('double.result.title', 'Результат раунда')}</h3>
        <span className="text-sm text-emerald-200">
          {t('double.result.sector', 'Сектор')}: <b>{winSector}</b> · {winColorLabel}
        </span>
      </div>

      <div className="space-y-3">
        {winners.map((winner, index) => (
          <div key={`${winner.chat_id || index}-${winner.color}`} className="rounded-xl border border-white/10 bg-dark-primary/55 p-3">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2 min-w-0">
                <img
                  src={winner.ava}
                  alt={winner.name}
                  className="w-10 h-10 rounded-full object-cover border border-white/10"
                />
                <div className="min-w-0">
                  <p className="text-white font-semibold truncate">{winner.name || t('double.common.player', 'Игрок')}</p>
                  <p className="text-xs text-text-secondary">
                    {t('double.result.betColor', 'Ставка')}: {winner.color}
                  </p>
                </div>
              </div>

              {Number(winner.win_crystal || 0) > 0 && (
                <span className="inline-flex items-center gap-1 text-emerald-300 font-semibold">
                  +{Number(winner.win_crystal || 0).toLocaleString()} <Gem className="w-4 h-4" />
                </span>
              )}
            </div>

            {winner.win_skin && (
              <div className="mt-3 rounded-lg border border-white/10 bg-black/30 p-2.5 flex items-center gap-2">
                <img
                  src={winner.win_skin.img}
                  alt={winner.win_skin.name}
                  className="w-12 h-12 object-contain"
                />
                <div className="min-w-0">
                  <p className="text-sm text-white truncate">{winner.win_skin.name}</p>
                  <p className="text-xs text-accent-primary inline-flex items-center gap-1">
                    {Number(winner.win_skin.cost || 0).toLocaleString()} <Gem className="w-3.5 h-3.5" />
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default DoubleWinnerSummary
